module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-4000-dacb6ab01991df835ddcaea6d8790c75.webp";